export interface FeeType {
  name: string;
  displayName: string;
}

export const FEE_TYPES: FeeType[] = [
  { name: 'CUSTODIAN_FEE', displayName: 'Custodian Fee' },
  { name: 'INCOME_ADJUSTMENT', displayName: 'Income Adjustment' },
  { name: 'INTEREST', displayName: 'Interest' },
  { name: 'MANAGEMENT_FEE', displayName: 'Management Fee' },
  { name: 'MISC_CHARGE', displayName: 'Misc Charge' },
  { name: 'P&L_ADJUSTMENT', displayName: 'P&L Adjustment' },
  { name: 'PERFORMANCE_FEE', displayName: 'Performance Fee' },
  { name: 'WITHHOLDING_TAX', displayName: 'Withholding Tax' },
];

export const getFeeTypeDisplay = (feeType: FeeType): string => {
  return feeType.displayName;
};
